document.querySelectorAll("input[type=text]").forEach((elem) => {
    elem.addEventListener("keyup", (e) => {
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity("Por favor, informe seu nome completo");
      } else if (e.target.validity.patternMismatch) {
        e.target.setCustomValidity("Seu nome não pode ser esse!");
      } else if (e.target.validity.tooShort) {
        e.target.setCustomValidity("É pra ser seu nome completo");
      } else {
        e.target.setCustomValidity("");
      }
    });
  });
  
  document.querySelectorAll("input[type=email]").forEach((elem) => {
    elem.addEventListener("keyup", (e) => {
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity("Por favor, informe seu e-mail");
      } else {
        e.target.setCustomValidity("");
      }
    });
  });
  
  document.querySelectorAll("input[type=tel]").forEach((elem) => {
    elem.addEventListener("keyup", (e) => {
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity(
          "Por favor, informe seu telefone corretamente"
        );
      } else {
        e.target.setCustomValidity("");
      }
    });
  });
  
  document.querySelectorAll("textarea").forEach((elem) => {
    elem.addEventListener("keyup", (e) => {
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity("Por favor, escreva sua mensagem");
      } else if (e.target.validity.tooShort) {
        e.target.setCustomValidity("Só isso? Escreve mais...");
      } else {
        e.target.setCustomValidity("");
      }
    });
  });
  